export default __webpack_public_path__ + "static/punk-lisa-1bfcb0dffc247e497a72b745cfe04546.gif";